/**
 * Registry of open CodSheet instances, ordered by opening time (last = topmost).
 *
 * Admin twin of the POS module (AR-26): the browser/hardware back button on
 * mobile must close the top overlay instead of navigating. CodSheets join via
 * the `kontySheetRegistry` provide (the kit's AD-3 seam) and get step-wise
 * back handling (e.g. ProductDetails: ingredients page → form; the guarded form itself
 * then stays — its ✕ / Poništi close it); the router guard consumes the rest (see
 * router/guards.ts).
 */
import type { SheetHandle } from 'app-components'

export type { SheetHandle }

const stack: SheetHandle[] = []

export function registerSheet(handle: SheetHandle): void {
    stack.push(handle)
}

export function unregisterSheet(handle: SheetHandle): void {
    const i = stack.indexOf(handle)
    if (i !== -1) stack.splice(i, 1)
}

/** Give the topmost open sheet a chance to consume a back press. */
export function handleSheetBack(): boolean {
    const top = stack[stack.length - 1]
    return top ? top.handleBack() : false
}
